import React, {useState} from 'react';
import { Chart as ChartJS, ArcElement, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { data } from './data/data.js';
import { Tooltip } from '@mui/material';
import { selectColorByScore } from '../helpers/selectColor.js';
import { LoadingButton } from '@mui/lab';
import CachedIcon from '@mui/icons-material/Cached';

ChartJS.register(ArcElement, Legend);

const OverallSentiment = ({ overallScore, onRescore }) => {
    const overallscore = parseInt(overallScore);
    const [isLoading, setIsLoading] = useState(false);
    
    const handleClick = () => {
        setIsLoading(true);
        onRescore();
    };

	return (
        <>
        {overallscore && (
            <section className="customer-sentiment__overall-sentiment">
                <div className="customer-sentiment__overall-sentiment-wrapper">
                    <h3 class="customer-sentiment__overall-sentiment_title">Overall Sentiment: </h3>
                    <Tooltip title="Regenerate Sentiment & Update Ticket">
                        <LoadingButton
                            size="small"
                            //className="customer-sentiment__overall-sentiment_button"
                            loading={isLoading} 
                            loadingPosition="end"
                            variant="outlined"
                            onClick={handleClick}
                            endIcon={<CachedIcon />}>Regenerate
                        </LoadingButton> 
                    </Tooltip>
                </div>
                <div className="customer-sentiment__overall-sentiment__legend">
                    <label className="customer-sentiment__overall-sentiment__positive" style={{ color: selectColorByScore(overallscore) }}>{overallscore}</label>
                    <label className="customer-sentiment__overall-sentiment__small_label">100</label>
                </div>
                <div className="customer-sentiment__overall-sentiment__pie-chart">
                    <Pie    
                        data={data(overallscore)}
                        height='150px'
                        options={{
                            maintainAspectRatio: false,
                            responsive: true
                        }}
                    />
                </div>
            </section>
        )}
        </>
	);
};

export default OverallSentiment;
